import { z } from 'zod';
export * from './archives.ts';
export * from './analysis-cases.ts';

export const tendersProductId = 'tenders';

/** Business verticals of the product. Each one brings its detection rules, AI tasks, criteria and sheet. */
export const verticalId = z.enum(['pv']);
export type VerticalId = z.infer<typeof verticalId>;

export const agencyInput = z.object({
    name: z.string().trim().min(1).max(200),
    address: z.string().trim().max(500).optional(),
    location: z.object({ longitude: z.number().min(-180).max(180), latitude: z.number().min(-90).max(90) }).optional(),
});
export type AgencyInput = z.infer<typeof agencyInput>;

/** An agency as exchanged over the API (dates as ISO 8601 strings). */
export const agency = z.object({
    id: z.uuid(),
    name: z.string(),
    address: z.string().nullable(),
    location: z.object({ longitude: z.number(), latitude: z.number() }).nullable(),
    createdAt: z.iso.datetime(),
});
export type Agency = z.infer<typeof agency>;

export { tendersOnboarding } from './onboarding.ts';
